import React from 'react'
import { IconButton } from '@mui/material'

import { useApplicationTheme } from '../contexts'

import { Icon } from './icon.tsx'

export const ThemeSwitch = (): React.ReactElement => {
  const { theme, setTheme } = useApplicationTheme()
  const handleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }
  return (
    <IconButton color="secondary" onClick={handleTheme}>
      <Icon name="ThemeMode" />
    </IconButton>
  )
}
